<era-panel>
  <ul class="fa-ul">
    @for (command of commands(); track command) {
      <li>
        <ml-timeline-item [commandProgress]="command"
                          [commandContent]="getCommandContent(command) | async"
                          (commandContentRequest)="handleCommandContentRequest($event)"></ml-timeline-item>
      </li>
    }
  </ul>
</era-panel>